/* Dependencies */
import { Product, FilterCategory } from '../../CoffeePicker.model';

/**
 * Return products based on the set filters.
 * @param products Array of Product
 * @param filterCategories Array of Filter Category
 * @returns Array of product containing products which match filters
 */
export const getProductsWithFiltersApplied = (
  products: Product[],
  filterCategories: FilterCategory[]
): Product[] => {
  const activeFlavourFilters = filterCategories
    .filter((f) => f.name == 'Flavour')[0]
    ?.filters.filter((x) => x.active);
  const activeTypeFilters = filterCategories
    .filter((f) => f.name == 'Type')[0]
    ?.filters.filter((x) => x.active);
  const activeProcessFilters = filterCategories
    .filter((f) => f.name == 'Process')[0]
    ?.filters.filter((x) => x.active);
  const activeOriginFilters = filterCategories
    .filter((f) => f.name == 'Origin')[0]
    ?.filters.filter((x) => x.active);
  const activeVarietalFilters = filterCategories
    .filter((f) => f.name == 'Varietal')[0]
    ?.filters.filter((x) => x.active);
  const activeRoastFilters = filterCategories
    .filter((f) => f.name == 'Roast')[0]
    ?.filters.filter((x) => x.active);

  return products.filter(
    (p) =>
      (activeFlavourFilters.length == 0 ||
        activeFlavourFilters.filter((x) => x.name == p.flavourProfile).length >
          0) &&
      (activeTypeFilters.length == 0 ||
        activeTypeFilters.filter((x) => x.name == p.type).length > 0) &&
      (activeProcessFilters.length == 0 ||
        activeProcessFilters.filter((x) => x.name == p.process).length > 0) &&
      (activeOriginFilters.length == 0 ||
        activeOriginFilters.filter((x) => x.name == p.origin).length > 0) &&
      (activeVarietalFilters.length == 0 ||
        activeVarietalFilters.filter((x) => x.name == p.varietal).length > 0) &&
      (activeRoastFilters.length == 0 ||
        activeRoastFilters.filter((x) => x.name == p.roast).length > 0)
  );
};
